import { render, staticRenderFns } from "./TableOpeningsVoip.vue?vue&type=template&id=47f6e4b1&scoped=true&"
import script from "./TableOpeningsVoip.vue?vue&type=script&lang=js&"
export * from "./TableOpeningsVoip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f6e4b1",
  null
  
)

export default component.exports